import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Paper, Table, TableHead, TableRow, TableCell, TableBody, IconButton } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { getEstimates2, type Estimate2ListItem } from '../services/estimate2Service';

const Estimates2Page: React.FC = () => {
  const [rows, setRows] = React.useState<Estimate2ListItem[]>([]);
  const [loading, setLoading] = React.useState(true);
  const navigate = useNavigate();

  React.useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const data = await getEstimates2();
        if (!mounted) return;
        setRows(data || []);
      } catch (e) {
        setRows([]);
      } finally {
        setLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, []);

  return (
    <Box sx={{ py: 2 }}>

      <Typography
        component="h1"
        sx={{
          fontFamily: 'Roboto, system-ui, -apple-system, Segoe UI, Helvetica, Arial',
          fontWeight: 600,
          fontSize: '48px',
          lineHeight: '100%',
          letterSpacing: 0,
          color: 'rgba(2, 2, 66, 1)',
          mt: '60px',
          mb: '25px'
        }}
      >
        Kosztorysy
      </Typography>

      <Typography sx={{
        fontFamily: 'Roboto, system-ui, -apple-system, Segoe UI, Helvetica, Arial',
        fontWeight: 400,
        fontSize: '18px',
        lineHeight: '100%',
        color: 'rgba(89, 89, 102, 1)',
        mb: '25px'
      }}>
        Lista kosztorysów. Dodaj nowy lub wczytaj istniejący plik.
      </Typography>

      <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
        <Button
          variant="contained"
          sx={{
            textTransform: 'none',
            fontFamily: 'Roboto, system-ui, -apple-system, Segoe UI, Helvetica, Arial',
            fontWeight: 500,
            fontSize: '14px',
            lineHeight: '100%',
            borderRadius: '4px',
            padding: '12px 16px',
            color: 'rgba(255, 255, 255, 1)',
            backgroundColor: 'rgba(2, 2, 66, 1)',
            '&:hover': { backgroundColor: 'rgba(2, 2, 66, 0.78)' }
          }}
        >
          Dodaj
        </Button>
        <Button
          variant="outlined"
          sx={{
            textTransform: 'none',
            fontFamily: 'Roboto, system-ui, -apple-system, Segoe UI, Helvetica, Arial',
            fontWeight: 500,
            fontSize: '14px',
            lineHeight: '100%',
            borderRadius: '4px',
            padding: '12px 16px'
          }}
        >
          Wczytaj
        </Button>
      </Box>

      <Paper variant="outlined" sx={{ borderColor: 'rgba(212,212,217,1)' }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Data</TableCell>
              <TableCell>Zamawiający</TableCell>
              <TableCell>Nazwa obiektu</TableCell>
              <TableCell align="right">Wartość</TableCell>
              <TableCell>Status</TableCell>
              <TableCell align="right">Akcje</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={6}>Ładowanie…</TableCell>
              </TableRow>
            ) : rows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={6}>Brak kosztorysów</TableCell>
              </TableRow>
            ) : (
              rows.map((r) => (
                <TableRow key={r.id} hover sx={{ cursor: 'pointer' }} onClick={()=> navigate(`/estimates2/${r.id}`)}>
                  <TableCell>{r.prepared_at}</TableCell>
                  <TableCell>{r.client}</TableCell>
                  <TableCell>{r.object_name}</TableCell>
                  <TableCell align="right">{(r.total_value || 0).toLocaleString('pl-PL', { style: 'currency', currency: 'PLN' })}</TableCell>
                  <TableCell>{r.status}</TableCell>
                  <TableCell align="right">
                    <IconButton size="small">
                      <MoreVertIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </Paper>
    </Box>
  );
};

export default Estimates2Page;


